import React, { useEffect, useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { addPopstatePage, isSdkBack, apple, getURLParams } from "./pages/utils";
import { ROUTE } from "./service/api";
import "./App.css";
import { cookiesGet } from "./service/cookiesGet";
import Loading from './components/Loading';

const Dubbing = React.lazy(() => import("./pages/dubbing/dubbing"));
const StudyReport = React.lazy(() => import("./pages/studyReport/studyReport"));
const Goods = React.lazy(() => import("./pages/goods/index"));
const Order = React.lazy(() => import("./pages/order/index"));
const OrderError = React.lazy(() => import("./pages/order/error"));
const OrderSuccess = React.lazy(() => import("./pages/order/success"));
const StudyWeekly = React.lazy(() => import("./pages/studyWeekly/studyWeekly"));
const Agreement = React.lazy(() => import("./pages/agreement"));
const Index = React.lazy(() => import("./pages/index"));
const Download = React.lazy(() => import("./pages/index/download"));
const OralShow = React.lazy(() => import("./pages/OralShow"));
const OralSplendidShow = React.lazy(() => import("./pages/OralSplendidShow"));
const KnowledgeReport = React.lazy(() => import("./pages/KnowledgeReport"));
const HighlightsReport = React.lazy(() => import("./pages/HighlightsReport"));
const ClockIn = React.lazy(() => import("./pages/ClockIn"));
const NewStudyReport = React.lazy(() => import("./pages/NewStudyReport"));
const PunchIn = React.lazy(() => import("./pages/PunchIn"));
const LuckyDraw = React.lazy(() => import("./pages/LuckyDraw"));
const PopUpWindow = React.lazy(() => import("./pages/PopUpWindow"));
const PunchInTemplate = React.lazy(() => import("./pages/PunchInTemplate"));
const Appraisal = React.lazy(() => import("./pages/Appraisal"));
const Transfer = React.lazy(() => import("./pages/Transfer"));
const Reader = React.lazy(() => import("./pages/Reader/reader"));

function App() {
  const [data, setData] = useState(false);
  const { proofUuid } = getURLParams();

  useEffect(() => {
    if (proofUuid) {
      cookiesGet(proofUuid).then((res) => {
        let { cookies } = res && res.body;
        const domain = window.location.hostname;

        setData(true);
        if (!cookies) return;
        const arr = cookies.split(";");

        console.info("app", cookies);
        arr.forEach((item) => {
          if (domain === "meta.youdao.com") {
            cookies = item + `;domain=youdao.com;path=/`;
          } else {
            cookies = item + `;domain=youdaozhixue.com;path=/`;
          }
          document.cookie = cookies;
        });
      });
    } else {
      setData(true);
    }

    const IS_GOODS = ["goods"].includes(ROUTE);

    if (apple()) return;

    if (!IS_GOODS) {
      window.fromUnity = function (msg) {
        if (typeof msg != "string") return;
        const unityInfo = msg.split("?");
        if (unityInfo[0] === "goback") {
          window.location = "unity:close_h5";
        }
      };
    }

    if (addPopstatePage() || isSdkBack()) {
      if (addPopstatePage()) {
        window.history.pushState("_android_close", "", "");
      }
      window.addEventListener("popstate", () => {
        if (window.closeWebView) {
          if (IS_GOODS) {
            window.goodsPayClose = true;
          } else {
            window.location = "unity:close_h5";
          }
        }
        window.closeWebView = true;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) return;

  return (
    <HashRouter>
      <React.Suspense fallback={<Loading></Loading>}>
        <Routes>
            <Route exact path="*" element={<Index />} />
            <Route exact path="/dubbing" element={<Dubbing />} />
            <Route exact path="/study-report" element={<StudyReport />} />
            <Route exact path="/study-weekly" element={<StudyWeekly />} />
            <Route exact path="/goods" element={<Goods />} />
            <Route exact path="/order" element={<Order />} />
            <Route exact path="/order/success" element={<OrderSuccess />} />
            <Route exact path="/order/error" element={<OrderError />} />
            <Route exact path="/agreement/*" element={<Agreement />} />
            <Route exact path="/download" element={<Download />} />
            <Route exact path="/oral-show" element={<OralShow />} />
            <Route
              exact
              path="/oral-splendid-show"
              element={<OralSplendidShow />}
            />
            <Route exact path="/knowledge-report" element={<KnowledgeReport />} />
            <Route exact path="/highlights-report" element={<HighlightsReport />} />
            <Route exact path="/clock-in" element={<ClockIn />} />
            <Route exact path="/new-study-report" element={<NewStudyReport />} />
            <Route exact path="/punch-in" element={<PunchIn />} />
            <Route exact path="/lucky-draw/*" element={<LuckyDraw />} />
            <Route exact path="/pop-up-window/*" element={<PopUpWindow />} />
            <Route exact path="/punch-in-template" element={<PunchInTemplate />} />
            <Route exact path="/appraisal" element={<Appraisal />} />
            <Route exact path="/transfer" element={<Transfer />} />
            <Route exact path="/reader/*" element={<Reader />} />
        </Routes>
      </React.Suspense>
    </HashRouter>
  );
}

export default App;
